import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import ExpandableController from './controllers/expandable-controller';
import ModalController from './controllers/modal-controller';
import SliderController from './controllers/slider-controller';
import SelectController from './controllers/select-controller';
import LeafletMapsController from './controllers/leaflet-maps-controller';
import TabsController from './controllers/tabs-controller';
import PostsController from './controllers/posts-controller';
import FileUploadController from './controllers/file-upload-controller';

import {lightbox} from './lightbox';
import {activeMenuLink, navigation} from './navigation';
import {animateButtons, animateNumbers} from './animations';
import {heroCards} from './hero';

require('./navigation');
require('./lightbox');

const application = Application.start();

application.register('axios-form', AxiosFormController);
application.register('modal', ModalController);
application.register('slider', SliderController);
application.register('expandable', ExpandableController);
application.register('select', SelectController);
application.register('map', LeafletMapsController);
application.register('tabs', TabsController);
application.register('posts', PostsController);
application.register('file-upload', FileUploadController);

document.querySelectorAll('ol[start], ul[start]').forEach((list) => {
    list.style.setProperty('--start', list.getAttribute('start'));
});

document.querySelectorAll('.open-form').forEach((btn) => {
    btn.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelectorAll('.text-media-block--form').forEach((form) => {
            form.closest('.text-media-block').classList.add('form-opened');
        })
    })
});

document.querySelectorAll('.text-media-block--form .icon').forEach((btn) => {
    btn.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelectorAll('.text-media-block--form').forEach((form) => {
            form.closest('.text-media-block').classList.remove('form-opened');
        });
    });
});

lightbox();
navigation();
activeMenuLink();
animateButtons();
animateNumbers();
heroCards();

document.querySelectorAll('a[href]').forEach(function(a) {
    const src = a.getAttribute('href');
    if (src) {
        let ext = src.split('/[#?]/')[0].split('.').pop().trim();
        ext = ext.split('&')[0];
        if (ext && ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv'].includes(ext)) {
            a.classList.add(`document-file`);
            a.classList.add(`${ext}-file`);
        }
    }
});